export default [
    {
        name: "filterSpecialChar",
        parm: {
            update: function (el, { value, modifiers }, vnode) {
                try {
                    console.log(el.children[0].value, 'here')
                    // 此处可以debug看看el具体值是什么,这里演示的是原生控件input,如果是使用element中的<el-input />标签,需要通过 el.children[0] 拿到原生input.
                    if (!el.children[0].value) {
                        return false
                    }
                    el.children[0].value = parseFloat(el.children[0].value) * 100
                    el.children[0].dispatchEvent(new Event(modifiers.lazy ? 'change' : 'input'))
                } catch (e) {
                }
            }
        }
    }
]


// WEBPACK FOOTER //
// ./src/common/directive.js